<template>
<div style="width: 100%;
    height: 100%;
    position: absolute;">
  <wlExplorer
      ref="wl-explorer-cpt"
      :headerDropdown="headerHandle"
      :columns="file_table_columns"
      :all-path="all_folder_list"
      :is-folder-fn="isFolderFn"
      :folderType="rource_type"
      :data="file_table_data"
      :props="explorer_prop"
      @upload='uploadFile'
      @uploadBefore='uploadBefore'
      size="small"
      @handleFolder="handleFolder"
      @search="fileSearch"
      @del="fileDel"
      @closeFade="closeOtherLayout(fade)"
    >
    <!-- <template slot="header-btn">
      <el-button style="margin-bottom:8px" @click="openGit">Git Terminal</el-button>
    </template> --> 
    </wlExplorer>
    <el-dialog
    title="Create Folder"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="30%"
    :modal="false">
    <span>Name:</span>
    <el-input v-model="folderName" placeholder="Enter folder name"></el-input>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">Cancel</el-button>
      <el-button type="primary" @click="createFolder">Confirm</el-button>
    </span>
  </el-dialog>
</div>

    
</template>

<script>
import submitBtn from "@/components/submit-btn"; // 导入防抖提交组件
import { closeOtherLayout } from "@/util"; // 导入关闭其他弹出类视图函数
import { arrayToTree } from "@/util/array"; // 导入关闭其他弹出类视图函数
import {
  getFileListApi, // 1获取文件夹列表
  getAllFoldersApi, // 4获取全部文件夹
  delFileApi // 6删除文件|文件夹
} from "@/api/explorer"; // 导入接口
import { findFilePath , getFileName, upload , deleteFile, generator} from "@/api/uvm/index"
const apiok = 200;

export default {
  name: "wl-explorer",
  components: {
    submitBtn
  },
  data() {
    const _GB = 1024 * 1024;
    return {
      dialogVisible: false,
      folderName: '',
      head:{},
      pathURl: '',
      load: {
        folder: false
      }, // loading管理
      fade: {
        folder: false
      }, // 弹出类视图管理
      headerHandle: [{ name: "权限", command: "auth" }], // 头部按钮更多操作-自定义权限
      file_table_columns: [
        {
          label: "名称",
          prop: "Name",
          minWidth: 120
        },
        {
          label: "修改日期",
          align: "center",
          width: 120,
          formatter(row) {
            return row.EditTime.split("T")[0] || "-";
          }
        },
        // {
        //   label: "类型",
        //   align: "center",
        //   width: 90,
        //   formatter(row) {
        //     return row.Type === 1 ? "文件夹" : row.SuffixName;
        //   }
        // },
        {
          label: "大小",
          minWidth: 90,
          align: "center",
          formatter(row) {
            if (row.Size === null) return "-";
            if (row.Size < 1024) {
              // 1024以下显示kb
              return row.Size + "KB";
            }
            if (row.Size < _GB) {
              // 1024*1024
              let _mb = (row.Size / 1024).toFixed(2);
              return parseFloat(_mb) + "MB";
            }
            let _gb = (row.Size / _GB).toFixed(2);
            return parseFloat(_gb) + "GB";
          }
        },
        {
          label: "创建日期",
          align: "center",
          width: 120,
          formatter(row) {
            return row.CreateTime.split("T")[0] || "-";
          }
        },
        // {
        //   label: "作者",
        //   minWidth: 100,
        //   align: "center",
        //   formatter(row) {
        //     return row.CreateUserName || "-";
        //   }
        // },
        // {
        //   label: "描述",
        //   minWidth: 100,
        //   formatter(row) {
        //     return row.Describe || "-";
        //   }
        // }
      ], // 自定义表格列
      file_table_data: [], // 表格数据
      all_folder_list: [], // 所有文件夹列表
      tree_folder_list: [], // 树形文件夹列表
      type: {
        folder: 1,
        img: 2,
        video: 3,
        other: 4
      }, // 文件类型
      rource_type: {
        self: 1 // 自建
      }, // 数据来源类型
      explorer_prop: {
        name: "Name",
        match: "Name",
        splic: true,
        suffix: "SuffixName",
        pathId: "Id",
        pathPid: "ParentId",
        pathName: "Name",
        pathChildren: "Children", // String 路径数据 children字段
        pathConnector: "\\", // String 路径父子数据拼接连接符,默认为'\'
        pathParents: "Parents", // String 路径数据所有直系祖先节点自增长identityId逗号拼接
        pathIdentityId: "IdentityId" // String 路径数据自增长id
      }, // 文件管理器配置项
      path: {}, // 路径数据
      folder_form: {
        ParentId: "",
        Name: "",
        preview: [],
        handle: []
      }, // 文件夹表单
      folder_rules: {
        Name: [{ required: true, message: "请填写文件夹名称", trigger: "blur" }]
      }, // 文件夹表单验证
      child_act_saved: {}, // 存储子组件数据，用于编辑更新
      tree_select_prop: {
        label: "Name",
        children: "Children"
      } // 树形下拉框配置项
    };
  },
  methods: {
    uploadBefore(file,path) {
      console.log(file,path)
      let p = path.pid || path.key || ""
      let data = new FormData()
      data.append('multiFiles',file)
      data.append('filePath',p)
      upload(data).then(res =>{
        console.log(res)
        this.$message.success(res.msg)
        this.getFileList(p)
      })
    },
    uploadFile(data, cb) {
      // console.log(data,cb)
      cb()
    },
    openGit() {
      this.$emit('openT','')
    },
    /**
     * 根据关键词搜索文件
     * file: Object 文件属性
     * update: Boolean 数据是否需要更新（不需要表示已存在）
     */
    fileSearch(file, update) {
      console.log(file, update)
      if (update && file.pid) {
        this.path = file;
        this.getFileList(file.pid);
      }
       if (update && file.key) {
        this.path = file;
        this.getFileListA({
          resourceName :file.key,
          resourcePath: this.pathURl
        });
      }
    },
    getFileListA(pid) {
      getFileName(pid).then(res => {
        this.file_table_data = []
        this.file_table_data = res.data;
        this.file_table_data.forEach(item => {
            item.Type = Number(item.fileNameType);
            // item.Type = 1
            item.RourceType = 1;
            item.Name = item.fileName
            item.CreateUserName = item.fileName
            item.FileType = 0
            item.EditTime =   item.updateFileTime
            item.CreateTime =   item.createFileTime
            item.Size = item.fileSize
            item.path = item.filePath
            item.ProjectId = item.filePath
            item.ParentId = item.filePath
            this.pathURl =  item.filePath.substring(0, item.filePath.lastIndexOf('/'));
            
            item.Id =  Math.floor(Math.random() * Math.pow(2, 32))
            console.log(this.pathURl)
            // item.ProjectId = item.filePath
      })
        this.file_table_data.sort()
      })
    },
    // 获取文件夹列表
    getFileList(pid) {
      findFilePath({
        resourcePath: pid
      }).then(res => {
        this.file_table_data = []
        this.file_table_data = res.data;
        this.file_table_data.forEach(item => {
            item.Type = Number(item.fileNameType);
            // item.Type = 1
            item.RourceType = 1;
            item.Name = item.fileName
            item.CreateUserName = item.fileName
            item.FileType = 0
            item.EditTime =   item.updateFileTime
            item.CreateTime =   item.createFileTime
            item.Size = item.fileSize
            item.path = item.filePath
            item.ProjectId = item.filePath
            item.ParentId = item.filePath
            item.Id =  Math.floor(Math.random() * Math.pow(2, 32))
             this.pathURl =  item.filePath.substring(0, item.filePath.lastIndexOf('/'));
            console.log(this.pathURl)
            // item.ProjectId = item.filePath
      })
        this.file_table_data.sort()
      })
    },
    /**
     * 编辑文件夹
     * act:Object 当前选中文件夹
     * type:String 操作类型 add添加edit编辑
     * file:Object 当前路径信息
     */
    handleFolder(act, type, file) {
      console.log(act, type, file)
      // this.path = file;
      // this.fade.folder = true;
      if (type === "add") {
        console.log(file)
          this.dialogVisible = true
          this.pathURl  = file.pid
        return;
      }
      // this.child_act_saved = act;
      // this.folder_form = { ...act };
    },
    createFolder() {
            // dialogVisible: true,
      // folderName: '',
      console.log(this.pathURl)
      generator({
        filePath:this.pathURl+'/'+this.folderName,
        fileType: "1" 
      }).then(res => {
        this.$message.success(res.msg)
         this.getFileList(this.pathURl);
         this.dialogVisible = false
         this.folderName = ''
      })
    },  
    // 提交文件夹表单
    submitFolderFrom(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.load.folder = true;
          setTimeout(() => {
            this.load.folder = false;
            // let res_data = data.data;
            let res_data = this.folder_form; // 由表单数据模拟服务器返回数据，此处应有服务器返回对应实体
            res_data.EditTime = res_data.CreateTime = "2019-11-11T11:11:11";
            res_data.Type = 1;
            if (!this.folder_form.Id) {
              // 新增
              if (this.folder_form.ParentId === this.path.id) {
                // 新增到当前路径
                this.file_table_data.unshift(res_data);
              } else {
                // 新增其他路径
                let _new_data = {
                  id: res_data.Id,
                  pid: res_data.ParentId,
                  path: res_data.Name
                };
                this.$refs["wl-explorer-cpt"].updateHistoryData(
                  { Id: res_data.ParentId },
                  [_new_data]
                );
              }
            } else {
              // 编辑
              this.child_act_saved.Name = res_data.Name;
              this.child_act_saved.Describe = res_data.Describe;
            }
            this.fade.folder = false;
            this.$message({
              showClose: true,
              message: "操作成功",
              type: "success"
            });
          }, 1000);
        } else {
          return false;
        }
      });
    },
    // 删除文件
    fileDel(data) {
      let normal_data_file = []; // 收集可删除文件
      data.forEach(item => {
        normal_data_file.push(item.path)
      })
     

      deleteFile({
        resourcePath: normal_data_file.join()
      }).then(res => {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "success"
          });
          this.getFileList(this.pathURl)
      })
    },
    // 获取所有文件夹
    getAllFolders() {
     let data =  getAllFoldersApi()
     if (data.code === apiok) {
          this.all_folder_list = data.data || [];
          let _list = [...this.all_folder_list];
          let options = {
            id: this.explorer_prop.pathId,
            pid: this.explorer_prop.pathPid,
            children: "Children"
          };
          this.tree_folder_list = arrayToTree(_list, options);
        }
    },
    // 判断是否文件夹函数
    isFolderFn(row) {
      return row.Type === this.type.folder;
    }
  },
  created() {
    // alert(1)
    console.log(11111)
      this.closeOtherLayout = closeOtherLayout;
    // this.getAllFolders();
    // this.getFileList();
    this.head = {
      Authorization: 'Bearer '+ '',
      'Content-Type': 'multipart/form-data' // 设置请求类型为 form-data
    }
    
    findFilePath({
      resourcePath: ''
    }).then(res => {
         this.file_table_data = res.data;

       this.file_table_data.forEach(item => {
    

          item.Type = Number(item.fileNameType);
          // item.Type = 1
          item.RourceType = 1;
          item.Name = item.fileName
          item.CreateUserName = item.fileName
          item.FileType = 0
          item.EditTime =   item.updateFileTime
          item.CreateTime =   item.createFileTime
          item.Size = item.fileSize
          item.path = item.filePath
          item.ProjectId = item.filePath
          item.ParentId = item.filePath
           this.pathURl =  item.filePath.substring(0, item.filePath.lastIndexOf('/'));
          // item.ProjectId = item.filePath
        })
    })
  }
};
</script>

<style>
.wl-explorer {
  /* height: 100vh!important;isOpenRight */
  position: absolute;
  height: 100%;

}
.fade-in-box{
  height: calc(100% - 180px);
}
.file-path-box {
  display: none !important;;
}
.wl-header-btn div:nth-of-type(2) {
  display: none!important;
}
</style>
